import { render, staticRenderFns } from "./ListarFormacoesEscolasDialog.vue?vue&type=template&id=b54372a4"
import script from "./ListarFormacoesEscolasDialog.vue?vue&type=script&lang=js"
export * from "./ListarFormacoesEscolasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports